module.exports = "<ng-template #template>\n  <ng-content></ng-content>\n</ng-template>\n";